module.exports = __webpack_public_path__ + "static/media/place_scholar_pin.32cd41d3.png";